import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { THEME_STORAGE_KEY } from '../constants/theme.constant';
import type { ThemeMode, ThemeState } from '../models/theme.model';

function systemMode(): ThemeMode {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: systemMode(),
      setMode: (mode) => set({ mode }),
    }),
    { name: THEME_STORAGE_KEY },
  ),
);
